module.exports = __webpack_public_path__ + "static/media/view-button-white.933490df.png";